// store.js

// Inicializar el carrito desde localStorage al crear el módulo
const initializeCart = () => {
  try {
    const carrito = localStorage.getItem('carrito');
    if (!!carrito) {
      const parsedCart = JSON.parse(carrito);
      return Array.isArray(parsedCart) ? parsedCart : [];
    }
    return [];
  } catch (error) {
    console.error('Error al inicializar el carrito desde localStorage:', error);
    localStorage.removeItem('carrito');
    return [];
  }
};

export default {
  state: {
    carrito: initializeCart()
  },
  mutations: {
    addItem(state, item) {
      const itemExistente = state.carrito.find(i => i.id === item.id);
      if (!itemExistente) {
        state.carrito.push(item);
        localStorage.setItem('carrito', JSON.stringify(state.carrito));
      }
    },
    deleteItem(state, id) {
      state.carrito = state.carrito.filter(item => item.id !== id);
      localStorage.setItem('carrito', JSON.stringify(state.carrito));
    },
    setCart(state, cart) {
      try {
        const carrito = localStorage.getItem('carrito');
        if (!!carrito) {
          const parsedCart = JSON.parse(carrito);
          state.carrito = Array.isArray(parsedCart) ? parsedCart : [];
        } else {
          state.carrito = [];
        }
      } catch (error) {
        console.error('Error al cargar el carrito desde localStorage:', error);
        state.carrito = [];
        localStorage.removeItem('carrito');
      }
    }
  },
  actions: {
    addItem({ commit, state }, item) {
      // Validar que el item no esté duplicado
      const itemExistente = state.carrito.find(i => i.id === item.id);
      if (itemExistente) {
        return Promise.reject(new Error('Este curso ya está en el carrito'));
      }

      // Validar que solo se puedan agregar cursos con el mismo cve_tema
      if (state.carrito.length > 0 && item.cve_tema) {
        const primerItem = state.carrito[0];
        // Si el primer item es un bloque, no aplicamos la restricción
        if (primerItem.id && primerItem.id.startsWith('bloque-')) {
          commit('addItem', item);
          return Promise.resolve();
        }
      }

      commit('addItem', item);
      return Promise.resolve();
    },
    deleteItem({ commit }, id) {
      commit('deleteItem', id);
    },
    setCart({ commit }, cart) {
      commit('setCart', cart);
    }
  },
  getters: {
    getCart: (state) => state.carrito,
    getItemsCount: (state) => state.carrito.length,
    getTotalAmount: (state) => state.carrito.reduce((total, item) => total + +item.precio, 0),
    canAddCourse: (state) => (cve_tema, cve_curso) => {
      // Si no hay cve_tema, permitir agregar (para compatibilidad con items antiguos)
      if (!cve_tema) {
        return { canAdd: true, reason: null };
      }

      // Si el carrito está vacío, puede agregarse
      if (!state.carrito || state.carrito.length === 0) {
        return { canAdd: true, reason: null };
      }

      // Si el curso ya está en el carrito, no puede agregarse
      const itemExistente = state.carrito.find(i => {
        if (cve_curso && i.cve_curso) {
          return String(i.cve_curso) === String(cve_curso);
        }
        if (cve_curso || cve_tema) {
          return i.id === `tema-${cve_curso || cve_tema}`;
        }
        return false;
      });
      if (itemExistente) {
        return { canAdd: false, reason: 'Este curso ya está en el carrito' };
      }


      // Si no hay curso con el mismo tema, permitir agregar
      return { canAdd: true, reason: null };
    },
  }
};



// WEBPACK FOOTER //
// ./src/modules/ecommerce.js